import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "text-sm text-gray-400" }

import { computed, ref } from 'vue';
import { required } from '@vuelidate/validators';
import {
	UiForm,
	UiButton,
	useLoading,
	useToggle,
	useForm
} from '@/ui-kit';
import { usePhoneNumbers } from '../composition';
import PhoneDetailsPanel from './PhoneDetailsPanel.vue';
import PhoneNumberSelect from './PhoneNumberSelect.vue';
import { usePhoneNumberDetails } from '../composition/use-phone-number-details';


export default /*#__PURE__*/_defineComponent({
  __name: 'PhoneNumberForwardCalls',
  props: {
    disabled: { type: Boolean }
  },
  emits: ["loading"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'loading', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {





const { isOpened, toggleOpened } = useToggle();
const { loading: toggling, toggleLoading } = useLoading();
const { phoneNumbers } = usePhoneNumbers();
const {
	selectedPhoneNumber,
	forwardingActive,
	phoneNumberDetails,
	updateForwardingNumber
} = usePhoneNumberDetails();
const {
	onSubmit,
	formData,
	resetForm,
	fillFormData,
	loading
} = useForm(
	{ forwardingNumber: '' },
	{ forwardingNumber: { required } }
);
const focused = ref(false);

const toggle = async () => {
	if (forwardingActive.value) {
		toggleLoading(true);
		emit('loading', true);
		await updateForwardingNumber({
			forwardingNumber: null
		}).finally(() => {
			toggleLoading(false);
			emit('loading', false);
		});
	} else {
		resetForm();
		toggleOpened(true);
	}
};

const selectedPhone = computed(() => {
	return phoneNumbers.value.find(
		(number) =>
			number.phoneNumber.trim() ===
				formData.forwardingNumber?.replace(
					/[ -]/g,
					''
				) &&
			number.id !== selectedPhoneNumber.value?.id
	);
});

const closeDialog = () => {
	toggleOpened(false);
	resetForm();
};

const submit = onSubmit(async (data) => {
	emit('loading', true);
	await updateForwardingNumber(data).finally(() => {
		emit('loading', false);
	});
	resetForm();
	closeDialog();
});

const onNumberClick = (number: string) => {
	if (!focused.value) {
		return;
	}
	formData.forwardingNumber = number;
};

const onBlur = async () => {
	setTimeout(() => {
		focused.value = false;
	});
};

fillFormData(phoneNumberDetails.value);

return (_ctx: any,_cache: any) => {
  const _component_ElDialog = _resolveComponent("ElDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(PhoneDetailsPanel, {
      title: "Forwarding all calls",
      disabled: __props.disabled,
      isActive: _unref(forwardingActive),
      loading: _unref(toggling),
      onToggle: toggle
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Forwarding all calls to: "),
        (!_unref(selectedPhone))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(_unref(phoneNumberDetails)?.forwardingNumber), 1)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(_unref(selectedPhone).friendlyName) + " ", 1),
              _createElementVNode("span", _hoisted_1, "( " + _toDisplayString(_unref(selectedPhone).phoneNumber) + " )", 1)
            ], 64))
      ]),
      _: 1
    }, 8, ["disabled", "isActive", "loading"]),
    _createVNode(_component_ElDialog, {
      "destroy-on-close": "",
      onClosed: closeDialog,
      customClass: "is-confirmation",
      modelValue: _unref(isOpened)
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(UiForm), { onSubmit: _unref(submit) }, {
          default: _withCtx(() => [
            _createVNode(PhoneNumberSelect, {
              label: "Forwarding number",
              inputName: "forwardingNumber",
              disabled: _unref(loading),
              modelValue: _unref(formData).forwardingNumber,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formData).forwardingNumber) = $event))
            }, null, 8, ["disabled", "modelValue"]),
            _createVNode(_unref(UiButton), { loading: _unref(loading) }, {
              default: _withCtx(() => [
                _createTextVNode("Save Changes")
              ]),
              _: 1
            }, 8, ["loading"])
          ]),
          _: 1
        }, 8, ["onSubmit"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})